import axios from "./axiosConfig";

const identityService = {
  live: () => axios.get("/security/live"),
  authCenter: () => axios.get("/security/auth-center"),
  overview: () => axios.get("/security/overview"),
  tokens: (params) => axios.get("/security/tokens", { params }),
  activeTokens: () => axios.get("/security/tokens/active"),
  revokeToken: (jti, reason) => axios.post(`/security/tokens/${encodeURIComponent(jti)}/revoke`, { reason }),
  sessions: () => axios.get("/security/sessions"),
  endSession: (id, reason) => axios.post(`/security/sessions/${id}/end`, { reason }),
  accounts: () => axios.get("/security/accounts"),
  createAccount: (payload) => axios.post("/security/accounts", payload),
  updateAccount: (id, payload) => axios.patch(`/security/accounts/${id}`, payload),
  revokeAccount: (id, reason) => axios.post(`/security/accounts/${id}/revoke`, { reason }),
  pulse: (path) => axios.post("/security/pulse", { path }),
};

export default identityService;
